export default __webpack_public_path__ + "static/media/steps.6c8a26c3.png";